"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.resolveError = resolveError;

/**
 * Normalize an unknown thrown value into an Error instance.
 *
 * JavaScript allows throwing any value — strings, numbers, objects, null.
 * Since catch clauses type the error as `unknown`, callers can't assume
 * it's an Error. NewRelic's noticeError() requires an Error object, so
 * this function ensures a consistent type at the logging boundary.
 */
function resolveError(value) {
  if (value instanceof Error) return value;
  if (typeof value === 'string') return new Error(value);
  return new Error(String(value));
}